/* eslint-disable react/prop-types */
import React, { Component } from "react";
import { Table, Form, Grid } from "semantic-ui-react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { protocolLogAction } from "actions/changeActiveItemActions";
import Constants from "utilities/Constants";
import Strings from "utilities/StringSelector";
import Utils from "utilities/Utils";
import { formatDeviceAddress, isBackendMasterAddress, matchesDeviceAddress } from "utilities/DeviceNameFormatter";

const UtilsInstance = new Utils();

const statusKeyArray = [Strings.GOOD_STRING_PROTOCOL, Strings.DIAGNOSTIC_STRING, Strings.FAULT_STRING, Strings.MISSING_SINGULAR_STRING];
const statusValueArray = [Constants.GOOD, Constants.DIAGNOSTIC, Constants.FAULT, Constants.MISSING];

class LiveList extends Component {
  // Intialize this component state
  constructor(props) {
    super(props);
    this.state = {
      formInput: "",
      column: null,
      sortDirection: "ascending",
      originalDevices: [],
      devices: [],
      isColumnClicked: false,
      baudrate: null,
      nMasters: 0,
      nSlaves: 0,
      errorMessages: [],
      firstScanFail: false,
      uptime: "",
      channelTag: "",
      controller: new AbortController()
    };
  }

  addAditionalInfoToDevices = (devices) => {

    for (let i = 0; i < devices.length; i++) {

      if (devices[i].status === Constants.OK) {
        devices[i].severity = 0;
      } else if (devices[i].status === Constants.DIAGNOSTIC) {
        devices[i].severity = 1;
      } else if (devices[i].status === Constants.FAULT) {
        devices[i].severity = 2;
      } else if (devices[i].status === Constants.MISSING) {
        devices[i].severity = 3;
      }
      else {
        devices[i].severity = 4;
      }

      // Adding order value
      let deviceName = devices[i].address;

      if (isBackendMasterAddress(deviceName)) {
        devices[i].contDiag = -1
        devices[i].fault = -1
        devices[i].retries = -1
        devices[i].order = 0;
      }
      else {
        devices[i].order = parseInt(deviceName);
      }
    }
    devices.sort(UtilsInstance.sortBy("order", false, parseInt));

    return devices;
  }

  // Sorts the table when the user clicks on one of the columns
  handleSort = (clickedColumn) => () => {

    this.setState({ 
      isColumnClicked: true 
    });

    // The user wants to order the live list by address ascending
    if (clickedColumn === "address" && this.state.sortDirection === "ascending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "order",
            false,
            parseInt)),
        sortDirection: "descending",
      });
    }
    // The user wants to order the live list by address descending
    else if (clickedColumn === "address" && this.state.sortDirection === "descending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "order",
            true,
            parseInt)),
        sortDirection: "ascending",
      });
    }
    // The user wants to order the live list by tag ascending
    else if (clickedColumn === "tag" && this.state.sortDirection === "ascending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "tag",
            false,
            function (a) { return UtilsInstance.treatUppercase(a); })),
        sortDirection: "descending",
      });
    }
    // The user wants to order the live list by tag descending
    else if (clickedColumn === "tag" && this.state.sortDirection === "descending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "tag",
            true,
            function (a) { return UtilsInstance.treatUppercase(a); })),
        sortDirection: "ascending",
      });
    }
    // The user wants to order the live list by amplitude ascending
    else if (clickedColumn === "retries" && this.state.sortDirection === "ascending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "retries",
            false,
            parseInt)),
        sortDirection: "descending",
      });
    }
    // The user wants to order the live list by amplitude descending
    else if (clickedColumn === "retries" && this.state.sortDirection === "descending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "retries",
            true,
            parseInt)),
        sortDirection: "ascending",
      });
    }
    // The user wants to order the live list by faults descending
    else if (clickedColumn === "faults" && this.state.sortDirection === "descending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "fault",
            true,
            parseInt)),
        sortDirection: "ascending",
      });
    }
    // The user wants to order the live list by min amplitude ascending
    else if (clickedColumn === "faults" && this.state.sortDirection === "ascending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "fault",
            false,
            parseInt)),
        sortDirection: "descending",
      });
    }
    // The user wants to order the live list by status ascending
    else if (clickedColumn === "status" && this.state.sortDirection === "ascending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "severity",
            false,
            parseInt)),
        sortDirection: "descending",
      });
    }
    // The user wants to order the live list by status descending
    else if (clickedColumn === "status" && this.state.sortDirection === "descending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "severity",
            true,
            parseInt)),
        sortDirection: "ascending",
      });
    }
    // The user wants to order the live list by status ascending
    else if (clickedColumn === "diagnostic" && this.state.sortDirection === "ascending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "contDiag",
            false,
            parseInt)),
        sortDirection: "descending",
      });
    }
    // The user wants to order the live list by status descending
    else if (clickedColumn === "diagnostic" && this.state.sortDirection === "descending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "contDiag",
            true,
            parseInt)),
        sortDirection: "ascending",
      });
    }
  }

    // Creates a list with entries that match the address passed on the form
  handleAddressSearch = () => {
    const searchedDevices = [];

    for (let i = 0; i < this.state.originalDevices.length; i++) {
      if (this.state.originalDevices[i].mestre === true && this.state.originalDevices[i].addressMestre !== undefined && this.state.originalDevices[i].addressMestre !== null) {
        if (matchesDeviceAddress(this.state.originalDevices[i].address, this.state.formInput, Strings)) {
          searchedDevices.push(this.state.originalDevices[i]);
        } else if (this.state.originalDevices[i].address === this.state.formInput) {
          searchedDevices.push(this.state.originalDevices[i]);
        } else if (this.state.originalDevices[i].addressMestre === parseInt(this.state.formInput)) {
          searchedDevices.push(this.state.originalDevices[i]);
        }
      } else {
        if (this.state.originalDevices[i].address === parseInt(this.state.formInput)) {
          searchedDevices.push(this.state.originalDevices[i]);
        }
        else if (this.state.originalDevices[i].address === this.state.formInput) {
          searchedDevices.push(this.state.originalDevices[i]);
        }
      }
    }

    if (searchedDevices.length > 0) {
      this.setState({ devices: searchedDevices });
    } else {
      this.setState({ devices: [] });
    }
  }
  // Creates a list with entries that match the status passed on the form
  handleSignalSearch = (statusArray) => {
    const searchedDevices = [];

    for (let i = 0; i < statusArray.length; i++) {
      for (let j = 0; j < this.state.originalDevices.length; j++) {
        if (this.state.originalDevices[j].status === statusArray[i]) {
          searchedDevices.push(this.state.originalDevices[j]);
        }
      }
    }

    if (searchedDevices.length > 0) {
      this.setState({ devices: searchedDevices });
    } else {
      this.setState({ devices: [] });
    }
  }

    /*
    If the user clicks on the table cell of a device a verification starts:
    If that device status is OK, Alarm, Duplicated or Online he is sent to the log page filtering all events by the address of the device
    If that device status is Offline or Fault he is asked to delete the device or be sent to the log list
    If that device status is different from any of the above (not expected) he is sent to the log list too
  */
    handleStatusCellClick = (address) => () => {
      this.props.onChangeLog();
      this.props.history.push({
        pathname: "/protocol-log",
        state: { deviceAddress: address }
      });
    }

  /*
    If the user typed a substring of one of the possible status: (In uppercase, lowercase or a mix of them)
    it returns and array containing the indexes to match against the json received from the server
  */
  matchFormInputStatus = () => {
    let matchedArray = [-1];
    let matchedIndex = 0;

    for (let i = 0; i < statusKeyArray.length; i++) {
      // Uppercases the user input before comparison to allow for a more flexible search
      // It doesn't matter if the user typed in uppercase, lowercase or any combination of them
      const status = statusKeyArray[i].toUpperCase();
      const upperCaseUserInput = this.state.formInput.toUpperCase();
      if (status.indexOf(upperCaseUserInput) !== -1) {
        matchedArray[matchedIndex] = i;
        matchedIndex++;
      }
    }

    return matchedArray;
  }

  /*
    Filters the page list showing only the devices that match the address or status typed in the form
  */
  handleSubmit = () => {
    const matchValueArray = this.matchFormInputStatus();
    let auxArray = [];

    for (let i = 0; i < matchValueArray.length; i++) {
      auxArray.push(statusValueArray[matchValueArray[i]]);
    }

    if (this.state.formInput !== "" && matchValueArray[0] !== -1) {
      this.handleSignalSearch(auxArray);
    }
    else if (this.state.formInput === "") {
      this.setState({ devices: this.state.originalDevices });
    }
    // If what the user typed is not a status and the form is not blank, try to see if he typed a number
    else {
      this.handleAddressSearch();
    }
  }

  retrieveData = async () => {
    // Retrieve devices list only if the input form is empty and the user didn't 
    // sort the table by clicking a column header
    if (this.state.formInput === "" && !this.state.isColumnClicked) {
      let promissesArray = [];

      promissesArray.push(
        fetch(Constants.MONITOR_REQUEST_IP_ADDRESS + "liveList/protocol", { mode: "cors", signal: this.state.controller.signal })
          .then(res => res.json())
          .then(data => data)
          .catch(() => "")
      );

      let resolvedPromisses = await Promise.all(promissesArray);

      let liveList = resolvedPromisses[0];

      if (liveList !== "") {
        liveList = this.addAditionalInfoToDevices(liveList);

        this.setState({
          devices: liveList,
          originalDevices: liveList
        });
      }
    }
  }

  /* 
    Create Status Cell
    parameters: 
    - device: JSON information of the device being added to the table
    - return: A new table cell stylized according to the current device status
  */
  createStatusCell = (device) => {
    if (device.status === Constants.GOOD) {
      return (
        <Table.Cell
          selectable
          width={2}
          style={okCellStyle}
          onClick={this.handleStatusCellClick(device.address, device.status)}>
          {Strings.GOOD_STRING_PROTOCOL}
        </Table.Cell>
      );
    }
    else if (device.status === Constants.DIAGNOSTIC) {
      return (
        <Table.Cell
          selectable
          width={2}
          style={diagnosticCellStyle}
          onClick={this.handleStatusCellClick(device.address, device.status)}>
          {Strings.DIAGNOSTIC_STRING}
        </Table.Cell>
      );
    }
    else if (device.status === Constants.FAULT) {
      return (
        <Table.Cell
          selectable
          width={2}
          style={badCellStyle}
          onClick={this.handleStatusCellClick(device.address, device.status)}>
          {Strings.FAULT_STRING}
        </Table.Cell>
      );
    }
    else if (device.status === Constants.MASTER) {
      return (
        <Table.Cell
          selectable
          width={2}
          style={masterCellStyle}>
          {Strings.MASTER_STRING}
        </Table.Cell>
      );
    }
    else if (device.status === Constants.MISSING) {
      return (
        <Table.Cell
          selectable
          width={2}
          style={missingCellStyle}>
          {Strings.MISSING_SINGULAR_STRING}
        </Table.Cell>
      );
    }
    else {
      return (
        <Table.Cell
          selectable
          width={2}
          style={unknownCellStyle}
          onClick={this.handleStatusCellClick(device.address, device.status)}>
          {Strings.UNKNOWN_STRING}
        </Table.Cell>
      );
    }
  }

  /*
    Adjusts the size of the table so that it does not exceed the
    browser window height limit
  */
  adjustTableMaxHeight = () => {
    const browserHeight = UtilsInstance.getBrowserWindowHeight();
    let newTableMaxHeight = browserHeight * Constants.SCALING_FACTOR_LIVE_TOPOLOGY;
    newTableMaxHeight = newTableMaxHeight.toString();
    newTableMaxHeight = newTableMaxHeight.concat("px");
    document.getElementById("main-table-container").style["maxHeight"] = newTableMaxHeight;
  }

  /*
    Saves the form input to the component state everytime the user
    types something in the form
  */
  handleChange = (e, { name, value }) => this.setState({ [name]: value })

  /// ---------------- Errors Accordion -----------------------------
  handleAccordionClick = (e, titleProps) => {
    const { index } = titleProps;
    const { accordionIndex } = this.state;
    const newIndex = accordionIndex === index ? -1 : index;

    this.setState({ accordionIndex: newIndex });
  };

  // ----------------- Lifecycle Methods ----------------
  componentDidMount() {
    sessionStorage.removeItem("auth");
    //console.log("Live List / channel: ", parseInt(localStorage.getItem(Constants.ACTIVE_CHANNEL)));
    this.retrieveData();
    // store intervalId in the state so it can be accessed later
    this.setState({
      intervalID: setInterval(this.retrieveData, 5000),
    });
    this.adjustTableMaxHeight();
  }

  componentWillUnmount() {
    this.state.controller.abort();
    clearInterval(this.state.intervalID);
  }

  componentDidUpdate() {
    this.adjustTableMaxHeight();
  }

  getDiagnosticsText = (device) => {
    if (device.status === "master") {
      return "-";
    }
    else {
      return device.contDiag;
    }
  }

  getRetriesText = (device) => {
    if (device.status === "master") {
      return "-";
    }
    else {
      return device.retries;
    }
  }

  getFaultsText = (device) => {
    if (device.status === "master") {
      return "-";
    }
    else {
      return device.fault;
    }
  }

  // Render the table containing all network devices
  render() {
    const column = this.state.column;
    const direction = this.state.sortDirection;
    const filter = this.state.formInput;

    const devices = this.state.devices.map(device => (
      (
        <Table.Row key={device.address}>
          <Table.Cell style={widthcellStyle} verticalAlign="middle">{formatDeviceAddress(device.address, Strings)}</Table.Cell>
          <Table.Cell style={widthcellStyleTag} verticalAlign="middle">{device.tag}</Table.Cell>
          <Table.Cell style={widthcellStyle} verticalAlign="middle">{this.getDiagnosticsText(device)}</Table.Cell>
          <Table.Cell style={widthcellStyle} verticalAlign="middle">{this.getRetriesText(device)}</Table.Cell>
          <Table.Cell style={widthcellStyle} verticalAlign="middle">{this.getFaultsText(device)}</Table.Cell>
          {this.createStatusCell(device)}
        </Table.Row>
      )
    ));

    return (
      <div>
        <Grid style={gridStyle} columns={3} verticalAlign="center" doubling>

          <Grid.Row>

            <Grid.Column>
              <Form onSubmit={this.handleSubmit} >
                <Form.Input
                  id="inputform"
                  placeholder={Strings.LIVE_LIST_INPUT_TEXT_PLACEHOLDER_PROTOCOL}
                  icon="search"
                  name="formInput"
                  value={filter}
                  onChange={this.handleChange} />
              </Form>
            </Grid.Column>

          </Grid.Row>
        </Grid>

        <Grid style={gridStyle} columns={1} doubling>
          <Grid.Row>

            <Grid.Column>
              <Table id="table-header" stackable striped celled textAlign="center">
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell
                      style={widthcellStyle}
                      sorted={column === "address" ? direction : null}
                      onClick={this.handleSort("address")}>
                      {Strings.ADDRESS}
                    </Table.HeaderCell>

                    <Table.HeaderCell
                      style={widthcellStyleTag}
                      sorted={column === "tag" ? direction : null}
                      onClick={this.handleSort("tag")}>
                      {Strings.TAG}
                    </Table.HeaderCell>

                    <Table.HeaderCell
                      style={widthcellStyle}
                      sorted={column === "diagnostic" ? direction : null}
                      onClick={this.handleSort("diagnostic")}>
                      {Strings.DIAGNOSTICS}
                    </Table.HeaderCell>

                    <Table.HeaderCell
                      style={widthcellStyle}
                      sorted={column === "retries" ? direction : null}
                      onClick={this.handleSort("retries")}>
                      {Strings.RETRIE}
                    </Table.HeaderCell>

                    <Table.HeaderCell
                      style={widthcellStyle}
                      sorted={column === "faults" ? direction : null}
                      onClick={this.handleSort("faults")}>
                      {Strings.FALHA}
                    </Table.HeaderCell>

                    <Table.HeaderCell
                      style={widthcellStyle}
                      sorted={column === "status" ? direction : null}
                      onClick={this.handleSort("status")}>
                      {Strings.STATUS_DEVICE}
                    </Table.HeaderCell>

                  </Table.Row>
                </Table.Header>
              </Table>

              <div id="main-table-container" style={tableStyle}>
                <Table id="main-table" sortable striped celled fixed selectable textAlign="center" columns={7}>
                  <Table.Body>{devices}</Table.Body>
                </Table>
              </div>

            </Grid.Column>

          </Grid.Row>
        </Grid>
      </div>
    );
  }
}

// CSS custom table stylization
const gridStyle = {
  marginLeft: "2vw",
  marginRight: "2vw"
};

const tableStyle = {
  overflowY: "scroll"
};


const okCellStyle = {
  color: "black",
  backgroundColor: "lime",
  verticalAlign: "middle",
  width: '15%'
};

const widthcellStyle = {
  width: '15%' // Ajuste conforme necessário para garantir que as colunas tenham o mesmo tamanho
};

const widthcellStyleTag = {
  width: '25%' // Ajuste conforme necessário para garantir que as colunas tenham o mesmo tamanho
};

const diagnosticCellStyle = {
  color: "black",
  backgroundColor: "yellow",
  verticalAlign: "middle",
  width: '15%'
};

const badCellStyle = {
  color: "black",
  backgroundColor: "#FF5722",
  verticalAlign: "middle",
  width: '15%'
};

const masterCellStyle = {
  color: "black",
  backgroundColor: "white",
  verticalAlign: "middle",
  width: '15%'
};

const unknownCellStyle = {
  color: "black",
  backgroundColor: "lightgrey",
  verticalAlign: "middle",
  width: '15%'
};

const missingCellStyle = {
  color: "white",
  backgroundColor: "#708090",
  verticalAlign: "middle",
  width: '15%'
};
// const nonStdDeviationCellStyle = {
//   backgroundColor: "#ff6600"
// };

// const dividerStyle = {
//   marginTop: "-0.2vh"
// };

const mapActionsToProps = {
  onChangeLog: protocolLogAction
};

export default connect(null, mapActionsToProps)(withRouter(LiveList));
